export const APICONSTANTS = {
  PROVIDERS: '/vh-providers',
  LOCATIONS: '/vh-locations',
  BUNDLES: '/vh-bundles',
  NETWORK_OFFERINGS: '/vh-offerings',
  NETWORKS: '/vh-networks',
};
